import React from "react";
import {stringColumn} from "../../../../helpers/commonColumns";
import moment from "moment";
import {Select, Tag} from "antd";
import {licenceStatusArray, LicenceStatusColor, LicenceStatusText} from "../../../../constants/LicenceStatus";
import DataType from "../../../../constants/DataType";
import InputDebounce from "../../../../components/InputDebounce";
import {getDetailsIcon} from "../../licenceActionButtons";
import {DATE_FORMAT} from "../../../../constants/dateFormat";

const licenceColumns = ({
                            primaryColor, onRevokeClick, onDeleteClick, onSendPassword, onLicenceSend, onPublicKeyDownload, showLicenceInfo,
                            onLicenceDownload, updateFiltersMap, companyOptions, softwareProductOptions, darkMode,
                            toggleLicenceDetails, licenceToShowDetailsFor, licenceDetailsVisible
                        }) => {

    let actionColumnWidth = 2 * 55;
    const twoToneColor = primaryColor;

    const tableColumnWithSearch = (columnKey, columnTitle) => {
        return stringColumn(columnKey, () => {
            return (
                <div>
                    <div><span>{columnTitle}</span></div>
                    <div onClick={(e) => e.stopPropagation()} style={{paddingTop: 5}}>
                        <InputDebounce allowClear={true} style={{width: '90%'}}
                                       onChange={(e) => {
                                           updateFiltersMap(columnKey, DataType.TEXT, e.target.value);
                                       }}/>
                    </div>
                </div>
            )
        })
    };

    const actionItems = record => getDetailsIcon({
        record,
        onRevokeClick,
        onDeleteClick,
        onLicenceSend,
        onSendPassword,
        onLicenceDownload,
        showLicenceInfo,
        toggleLicenceDetails,
        licenceDetailsVisible,
        onPublicKeyDownload,
        twoToneColor
    }, false);

    let actions = {
        title: 'Actions',
        key: 'action',
        width: actionColumnWidth,
        render: (text, record) => (
            <span>{actionItems(record)}</span>
        )
    };

    return [
        {
            title: () => <div onClick={(e) => e.stopPropagation()}>
                <div><span>Company</span></div>
                <Select
                    allowClear
                    showSearch
                    style={{width: '100%'}}
                    optionFilterProp="children"
                    onChange={(e) => {
                        updateFiltersMap('company', DataType.SELECT, e);
                    }}
                    dropdownClassName={darkMode && 'dark-mode'}
                >
                    {companyOptions.map(({id, companyName}) => {
                        return (
                            <Select.Option key={id}
                                           value={id}>{companyName}</Select.Option>
                        )
                    })}
                </Select>
            </div>,
            dataIndex: 'company',
            key: 'company',
            sorter: (a, b) => {
                if (a.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName < b.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName) //sort string ascending
                    return -1;
                if (a.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName > b.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName)
                    return 1;
                return 0;
            },
            render: (licence, item) => item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.companyResponse.companyName
        },
        {
            title: () => <div onClick={(e) => e.stopPropagation()}>
                <div><span>Software Product</span></div>
                <Select
                    allowClear
                    showSearch
                    style={{width: '100%'}}
                    optionFilterProp="children"
                    onChange={(e) => {
                        updateFiltersMap('softwareProduct', DataType.SELECT, e);
                    }}
                    dropdownClassName={darkMode && 'dark-mode'}
                >
                    {softwareProductOptions.map(({id, code}) => {
                        return (
                            <Select.Option key={id}
                                           value={id}>{code}</Select.Option>
                        )
                    })}
                </Select>
            </div>,
            dataIndex: 'softwareProduct',
            key: 'softwareProduct',
            sorter: (a, b) => {
                if (a.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code < b.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code) //sort string ascending
                    return -1;
                if (a.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code > b.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code)
                    return 1;
                return 0;
            },
            render: (licence, item) => item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.softwareProductResponse.code
        },
        {
            title: () => <div onClick={(e) => e.stopPropagation()}>
                <div><span>Code</span></div>
                <InputDebounce
                    showSearch
                    style={{width: '100%'}}
                    onChange={(e) => {
                        updateFiltersMap('code', DataType.TEXT, e.target.value);
                    }}
                />
            </div>,
            dataIndex: 'code',
            key: 'code',
            sorter: (a, b) => {
                if (a.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code < b.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code) //sort string ascending
                    return -1;
                if (a.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code > b.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code)
                    return 1;
                return 0;
            },
            render: (licence, item) => item.companyHasSoftwareProductWithCompanyAndSoftwareProductResponse.code
        },
        tableColumnWithSearch('licenceNumber', 'Licence Number'),
        tableColumnWithSearch('currentProductVersion', 'Current Version'),
        {
            title: () => <div onClick={(e) => e.stopPropagation()}>
                <div><span>Status</span></div>
                <Select
                    allowClear
                    showSearch
                    style={{width: '100%'}}
                    optionFilterProp="children"
                    onChange={(e) => {
                        updateFiltersMap('status', DataType.SELECT, e);
                    }}
                    dropdownClassName={darkMode && 'dark-mode'}
                >
                    {licenceStatusArray.map(option => {
                        return (
                            <Select.Option key={option.id}
                                           value={option.id}>{option.value}</Select.Option>
                        )
                    })}
                </Select>
            </div>,
            dataIndex: 'status',
            key: 'status',
            sorter: (a, b) => {
                if (a.status < b.status) //sort string ascending
                    return -1;
                if (a.status > b.status)
                    return 1;
                return 0;
            },
            render: status => <Tag color={LicenceStatusColor[status]}>{LicenceStatusText[status]}</Tag>
        },
        tableColumnWithSearch('statusDescription', 'Status Description'),
        {
            title: () => <div onClick={(e) => e.stopPropagation()}>
                <div><span>Issue Date</span></div>
                <InputDebounce
                    showSearch
                    className='date-input'
                    style={{width: '100%'}}
                    onChange={(e) => {
                        updateFiltersMap('issueDate', DataType.DATE, e.target.value);
                    }}
                />
            </div>,
            dataIndex: 'issueDate',
            key: 'issueDate',
            sorter: (a, b) => {
                const firstItemIssueDate = moment(a.issueDate),
                    secondItemIssueDate = moment(b.issueDate);
                if (firstItemIssueDate < secondItemIssueDate) //sort string ascending
                    return -1;
                if (firstItemIssueDate > secondItemIssueDate)
                    return 1;
                return 0;
            },
            render: issueDate => issueDate && moment(issueDate).format(DATE_FORMAT)
        },
        actions
    ]
};

export default licenceColumns;